import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EApiType, EDataTableType, EModuleType, TableHeaders } from '../../../data/Constants';
import { MaintenanceTable } from '../../Layouts/DataTable';
import { getAllProperties, getPropertyAssociations } from '../../../store/states/PropertySlice';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, AppState } from '../../../store/AppStore';
import { useApiError } from '../../../hooks';
import { setColumnsData } from '../../../services/DataHelperFunctions';

import type { IManagementProps } from '../../../../types';

export const PropertyAssociation = (props: IManagementProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const errorElement = useApiError(EApiType.PropertyAssociationKey);
  const propertyList = useSelector((state: AppState) => state.dataMaintainance.propertyList);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    dispatch(getAllProperties({ token: props.token }));
  }, []);

  useEffect(() => {
    setColumnsData(propertyList, setColumns, TableHeaders[EDataTableType.PropertyAssociation].main);
  }, [propertyList]);

  if (errorElement) return errorElement;

  return (
    <>
      <h3 className="mainHeader"> {t('header.propertyAssociation')}</h3>
      <MaintenanceTable
        token={props.token}
        type={EDataTableType.PropertyAssociation}
        getDataList={getPropertyAssociations}
        moduleType={EModuleType.Datamaintainance}
        columns={columns}
      />
    </>
  );
};
